import { createReducer } from "redux-create-reducer";
import {
  CHANGE_DECISION_DETAILS,
  MODAL_MQ_CHANGE_DECISION_OPEN,
  SET_CHANGE_DECISION_DETAILS,
  TOGGLE_MODAL_MQ_CHANGE_DECISION,
} from "../types";

const initialState = {
  [MODAL_MQ_CHANGE_DECISION_OPEN]: false,
  [CHANGE_DECISION_DETAILS]: null,
};

const changeDecisionModalsReducer = createReducer(initialState, {
  [TOGGLE_MODAL_MQ_CHANGE_DECISION]: (state, { payload }) => {
    return {
      ...state,
      [MODAL_MQ_CHANGE_DECISION_OPEN]: payload,
    };
  },
  [SET_CHANGE_DECISION_DETAILS]: (state, { payload }) => {
    return {
      ...state,
      [CHANGE_DECISION_DETAILS]: payload,
    };
  },
});

export default changeDecisionModalsReducer;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/reducers/changeDecisionModalReducer.js